<section class="fun-facts-area ptb-100">
    <div class="container">
        <div class="row" >
            <div class="col-lg-3 col-sm-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="100">00</span><span class="sign-icon">+</span></h3>
                    <p>Projects Completed</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="100">00</span><span class="sign-icon">%</span></h3>
                    <p>Client Satisfaction</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="99">00</span><span class="sign-icon">%</span></h3>
                    <p>Availability</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6">
                <div class="single-fun-facts">
                    <h3><span class="odometer" data-count="10000">00</span><span class="sign-icon">+</span></h3>
                    <p>Business Enquiries</p>
                </div>
            </div>
        </div>
    </div>
</section>